<!-- 搜索汽配件 -->
<template>
    <div class="searchAp-ctn" v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-row">
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.JointSearch.IsShow">
                            {{ searchShowSets.JointSearch.Title }}
                        </div>
                        <el-input
                            v-if="searchShowSets.JointSearch.IsShow"
                            class="search-item"
                            size="small"
                            v-model="searchData.JointSearch"
                            :placeholder="'用分隔符“' + (separator == ' ' ? '空格' : separator) + '”隔开'"
                            @keyup.enter.native="handleSearch"
                        ></el-input>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.APCode.IsShow">
                            {{ searchShowSets.APCode.Title }}
                        </div>
                        <el-input
                            v-if="searchShowSets.APCode.IsShow"
                            class="search-item"
                            size="small"
                            v-model="searchData.APCode"
                            :placeholder="searchShowSets.APCode.Placeholder"
                            @keyup.enter.native="handleSearch"
                        ></el-input>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.GoodName.IsShow">
                            {{ searchShowSets.GoodName.Title }}
                        </div>
                        <el-input
                            v-if="searchShowSets.GoodName.IsShow"
                            class="search-item"
                            size="small"
                            v-model.trim="searchData.GoodName"
                            :placeholder="searchShowSets.GoodName.Placeholder"
                            @keyup.enter.native="handleSearch"
                        ></el-input>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.AutoSerise.IsShow">
                            {{ searchShowSets.AutoSerise.Title }}
                        </div>
                        <el-input
                            class="search-item"
                            size="small"
                            v-if="searchShowSets.AutoSerise.IsShow"
                            v-model.trim="searchData.AutoSerise"
                            :placeholder="searchShowSets.AutoSerise.Placeholder"
                            @keyup.enter.native="handleSearch"
                        ></el-input>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.GoodCode.IsShow">
                            {{ searchShowSets.GoodCode.Title }}
                        </div>
                        <el-input
                            class="search-item"
                            size="small"
                            v-if="searchShowSets.GoodCode.IsShow"
                            v-model.trim="searchData.GoodCode"
                            :placeholder="searchShowSets.GoodCode.Placeholder"
                            @keyup.enter.native="handleSearch"
                        ></el-input>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.Cate.IsShow">
                            {{ searchShowSets.Cate.Title }}
                        </div>
                        <div class="search-item goods-categories" v-if="searchShowSets.Cate.IsShow">
                            <el-select
                                size="small"
                                style="width: 100%"
                                v-model="searchData.Cate"
                                multiple
                                collapse-tags
                                filterable
                                clearable
                                @visible-change="getGoodsType($event)"
                                @keyup.enter.native="handleSearch"
                            >
                                <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                    <div class="option-content">
                                        <div>{{ optionItem.Text }}</div>
                                    </div>
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.BrandId.IsShow">
                            {{ searchShowSets.BrandId.Title }}
                        </div>
                        <div class="search-item goods-categories" v-if="searchShowSets.BrandId.IsShow">
                            <el-select
                                v-model="searchData.BrandName"
                                multiple
                                collapse-tags
                                filterable
                                clearable
                                size="small"
                                style="width: 100%"
                                @visible-change="getGoodsBrand($event)"
                                @keyup.enter.native="handleSearch"
                            >
                                <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.Invent.IsShow">
                            {{ searchShowSets.Invent.Title }}
                        </div>
                        <el-select
                            v-if="searchShowSets.Invent.IsShow"
                            size="small"
                            class="search-item"
                            style="width: 90px"
                            v-model="searchData.Symbol"
                            clearable
                            :placeholder="searchShowSets.Invent.Placeholder"
                            @keyup.enter.native="handleSearch"
                        >
                            <el-option key=">=" label=">=" value=">="></el-option>
                            <el-option key=">" label=">" value=">"></el-option>
                            <el-option key="<=" label="<=" value="<="></el-option>
                            <el-option key="<" label="<" value="<"></el-option>
                            <el-option key="=" label="=" value="="></el-option>
                            <el-option key="!=" label="!=" value="!="></el-option>
                            <el-option key="between" label="区间" value="between"></el-option>
                        </el-select>
                        <el-input
                            v-if="searchShowSets.Invent.IsShow"
                            class="search-item"
                            size="small"
                            style="width: 90px"
                            v-model.trim="searchData.Invent1"
                            @keyup.enter.native="handleSearch"
                        ></el-input>
                        <el-input
                            class="search-item"
                            size="small"
                            style="width: 90px"
                            v-model.trim="searchData.Invent2"
                            @keyup.enter.native="handleSearch"
                            v-if="searchData.Symbol == 'between' && searchShowSets.Invent.IsShow"
                        ></el-input>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.Size.IsShow">
                            {{ searchShowSets.Size.Title }}
                        </div>
                        <el-input
                            v-if="searchShowSets.Size.IsShow"
                            class="search-item"
                            size="small"
                            v-model.trim="searchData.Size"
                            :placeholder="searchShowSets.Size.Placeholder"
                            @keyup.enter.native="handleSearch"
                        ></el-input>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.GoodDesc.IsShow">
                            {{ searchShowSets.GoodDesc.Title }}
                        </div>
                        <el-input
                            v-if="searchShowSets.GoodDesc.IsShow"
                            class="search-item"
                            size="small"
                            v-model.trim="searchData.GoodDesc"
                            :placeholder="searchShowSets.GoodDesc.Placeholder"
                            @keyup.enter.native="handleSearch"
                        ></el-input>
                    </div>
                    <div class="flex" v-if="isShowProject">
                        <div class="search-name">
                            合作项目
                        </div>
                        <el-select
                            class="search-item"
                            v-model="searchData.ProjectId"
                            filterable
                            clearable
                            size="small"
                            @visible-change="projectVisibleChange"
                            placeholder="请选择合作项目"
                        >
                            <el-option v-for="optionItem in projectList" :key="optionItem.ProjectId" :label="optionItem.ProjectName" :value="optionItem.ProjectId"> </el-option>
                        </el-select>
                    </div>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button v-if="canEdit != 'canNot'" size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="showAddAPDialog">新增配件</el-button>
                    <el-button v-if="!OnlyOneOption" class="search-btn btn-primary" size="small" @click="chooseAPs()">确定 (选中{{ selection.length }}项)</el-button>
                    <el-button v-if="!OnlyOneOption && isSearch" class="search-btn btn-primary" size="small" @click="chooseAllAPs()"
                        >确定 (筛选结果{{ tableDataLength }}项)</el-button
                    >
                    <el-button size="small" icon="el-icon-setting" type="primary" class="search-btn" @click="showSearchSetDialog()">搜索设置</el-button>
                    <el-button size="small" icon="el-icon-setting" type="primary" class="search-btn" @click="showTableSetDialog()">表格设置</el-button>
                </div>
            </div>
        </div>
        <div class="dialog-search-table-ctn search-table-i">
            <el-table
                ref="dialogTable"
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border
                height="500px"
                style="width: 100%; margin-bottom: 5px"
                @selection-change="onColumnSelect"
                @sort-change="sortChange"
                @row-click="rowClick"
                @cell-dblclick="dblChooseAps"
                v-el-table-infinite-scroll="tableLoad"
                :row-key="getRowKeys"
                highlight-current-row
            >
                <el-table-column type="selection" width="55" reserve-selection v-if="!OnlyOneOption" fixed="left"></el-table-column>
                <el-table-column
                    v-if="columnShowSets.APCode.IsShow"
                    :width="columnShowSets.APCode.Width > 0 ? columnShowSets.APCode.Width + 'px' : '200px'"
                    :label="columnShowSets.APCode.ColumnName"
                    prop="APCode"
                    sortable="custom"
                    show-overflow-tooltip
                    fixed="left"
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.GoodCode.IsShow"
                    :width="columnShowSets.GoodCode.Width > 0 ? columnShowSets.GoodCode.Width + 'px' : '200px'"
                    :label="columnShowSets.GoodCode.ColumnName"
                    prop="GoodCode"
                    sortable="custom"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.GoodName.IsShow"
                    :width="columnShowSets.GoodName.Width > 0 ? columnShowSets.GoodName.Width + 'px' : '150px'"
                    :label="columnShowSets.GoodName.ColumnName"
                    prop="GoodName"
                    sortable="custom"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.AutoSerise.IsShow"
                    :width="columnShowSets.AutoSerise.Width > 0 ? columnShowSets.AutoSerise.Width + 'px' : '250px'"
                    :label="columnShowSets.AutoSerise.ColumnName"
                    prop="AutoSerise"
                    sortable="custom"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.Cate.IsShow"
                    :width="columnShowSets.Cate.Width > 0 ? columnShowSets.Cate.Width + 'px' : '120px'"
                    :label="columnShowSets.Cate.ColumnName"
                    prop="Cate"
                    sortable="custom"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.Brand.IsShow"
                    :width="columnShowSets.Brand.Width > 0 ? columnShowSets.Brand.Width + 'px' : '120px'"
                    :label="columnShowSets.Brand.ColumnName"
                    prop="Brand"
                    sortable="custom"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="ProjectName"
                    v-if="isShowProject"
                    width="160px"
                    label="合作项目"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.Unit.IsShow"
                    :width="columnShowSets.Unit.Width > 0 ? columnShowSets.Unit.Width + 'px' : '60px'"
                    :label="columnShowSets.Unit.ColumnName"
                    prop="Unit"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.Inventory.IsShow"
                    :width="columnShowSets.Inventory.Width > 0 ? columnShowSets.Inventory.Width + 'px' : '80px'"
                    :label="columnShowSets.Inventory.ColumnName"
                    prop="Inventory"
                    sortable="custom"
                    show-overflow-tooltip
                    ><template slot-scope="scope">
                        {{ StorageId ? scope.row.StorageInventory : scope.row.Inventory }}
                    </template></el-table-column
                >
                <el-table-column
                    v-if="columnShowSets.Remaining.IsShow"
                    :width="columnShowSets.Remaining.Width > 0 ? columnShowSets.Remaining.Width + 'px' : '80px'"
                    :label="columnShowSets.Remaining.ColumnName"
                    prop="Remaining"
                    show-overflow-tooltip
                    ><template slot-scope="scope">
                        {{ (StorageId ? scope.row.StorageInventory : scope.row.Inventory) + (isAddWaitIn ? scope.row.POrderWaitInQuantity : 0) - scope.row.OrderWaitOutQuantity }}
                    </template></el-table-column
                >
                <el-table-column
                    v-if="columnShowSets.OrderWaitOutQuantity.IsShow"
                    :width="columnShowSets.OrderWaitOutQuantity.Width > 0 ? columnShowSets.OrderWaitOutQuantity.Width + 'px' : '80px'"
                    :label="columnShowSets.OrderWaitOutQuantity.ColumnName"
                    prop="OrderWaitOutQuantity"
                    show-overflow-tooltip
                    ><template slot-scope="scope">
                        {{ scope.row.OrderWaitOutQuantity }}
                    </template></el-table-column
                >
                <el-table-column
                    v-if="columnShowSets.POrderWaitInQuantity.IsShow"
                    :width="columnShowSets.POrderWaitInQuantity.Width > 0 ? columnShowSets.POrderWaitInQuantity.Width + 'px' : '80px'"
                    :label="columnShowSets.POrderWaitInQuantity.ColumnName"
                    prop="POrderWaitInQuantity"
                    show-overflow-tooltip
                    ><template slot-scope="scope">
                        {{ scope.row.POrderWaitInQuantity }}
                    </template></el-table-column
                >
                <el-table-column v-if="isIntentShow" width="80px" label="在订数" prop="IntenCount" show-overflow-tooltip></el-table-column>
                <el-table-column
                    v-if="columnShowSets.CostPrice.IsShow"
                    :width="columnShowSets.CostPrice.Width > 0 ? columnShowSets.CostPrice.Width + 'px' : '110px'"
                    :label="columnShowSets.CostPrice.ColumnName"
                    prop="CostPrice"
                    sortable="custom"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.Price.IsShow"
                    :width="columnShowSets.Price.Width > 0 ? columnShowSets.Price.Width + 'px' : '110px'"
                    :label="columnShowSets.Price.ColumnName"
                    prop="Price"
                    sortable="custom"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.MarketPrice.IsShow"
                    :width="columnShowSets.MarketPrice.Width > 0 ? columnShowSets.MarketPrice.Width + 'px' : '110px'"
                    :label="columnShowSets.MarketPrice.ColumnName"
                    prop="MarketPrice"
                    sortable="custom"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.Origin.IsShow"
                    :width="columnShowSets.Origin.Width > 0 ? columnShowSets.Origin.Width + 'px' : '120px'"
                    :label="columnShowSets.Origin.ColumnName"
                    prop="Origin"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="Quality"
                    sortable="custom"
                    v-if="columnShowSets.Quality.IsShow"
                    :width="columnShowSets.Quality.Width > 0 ? columnShowSets.Quality.Width + 'px' : '80px'"
                    :label="columnShowSets.Quality.ColumnName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.Size.IsShow"
                    :width="columnShowSets.Size.Width > 0 ? columnShowSets.Size.Width + 'px' : '140px'"
                    :label="columnShowSets.Size.ColumnName"
                    prop="Size"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.Size2.IsShow"
                    :width="columnShowSets.Size2.Width > 0 ? columnShowSets.Size2.Width + 'px' : '140px'"
                    :label="columnShowSets.Size2.ColumnName"
                    prop="Size2"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="Texture"
                    v-if="columnShowSets.Texture.IsShow"
                    :width="columnShowSets.Texture.Width > 0 ? columnShowSets.Texture.Width + 'px' : '100px'"
                    :label="columnShowSets.Texture.ColumnName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="Color"
                    v-if="columnShowSets.Color.IsShow"
                    :width="columnShowSets.Color.Width > 0 ? columnShowSets.Color.Width + 'px' : '100px'"
                    :label="columnShowSets.Color.ColumnName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="GoodDesc"
                    v-if="columnShowSets.GoodDesc.IsShow"
                    :width="columnShowSets.GoodDesc.Width > 0 ? columnShowSets.GoodDesc.Width + 'px' : '200px'"
                    :label="columnShowSets.GoodDesc.ColumnName"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="CreateTime"
                    sortable="custom"
                    v-if="columnShowSets.CreateTime.IsShow"
                    :width="columnShowSets.CreateTime.Width > 0 ? columnShowSets.CreateTime.Width + 'px' : '160px'"
                    :label="columnShowSets.CreateTime.ColumnName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column v-if="OnlyOneOption" fixed="right" label="操作" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button class="btn-primary" title="选中" size="mini" style="padding: 5px 12px" @click="chooseAP(scope.row)">选中</el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-else fixed="right" label="进销历史" width="100">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <img src="@/assets/images/sup.png" title="采购历史" style="width: 27px; height: 27px" @click="showHistories(scope.row.EntpTempGoodsId)" />
                            <img src="@/assets/images/cus.png" style="width: 26px; height: 26px; margin-left: 4px" title="销售历史" @click="showSaleStat(scope.row)" />
                            <img src="@/assets/images/analysis.png" style="width: 23px; height: 23px; margin-left: 6px" title="数据分析" @click="analysis(scope.row)" />
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--    新增库存    -->
        <transInventory v-if="addAPVisible" :dialogFormVisible="addAPVisible" @closeDialog="closeAddAPDialog"></transInventory>
        <el-dialog :close-on-click-modal="false" title="自定义列展示设置" @close="closeDialog" :visible.sync="tableSetsVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="tableSetsVisible">
                <tableSets :tableCode="tableCode" @closeDialog="closeDialog"></tableSets>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="自定义搜索条件展示设置" @close="closeDialog" :visible.sync="searchSetVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="searchSetVisible">
                <searchSets tableCode="SearchUnionAP" @closeDialog="closeDialog"></searchSets>
            </div>
        </el-dialog>
        <!--    采购历史    -->
        <el-dialog
            :close-on-click-modal="false"
            title="采购历史"
            :visible.sync="historyVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
        >
            <div v-if="historyVisible">
                <APPurchaseHistory
                    ref="APPurchaseHistory"
                    :EntpTempGoodsId="hisGoodsId"
                    :EntpCusId="EntpCusId"
                    :EntpCusName="EntpCusName"
                    :Source="Source"
                    @closeDialog="
                        () => {
                            historyVisible = false;
                        }
                    "
                ></APPurchaseHistory>
            </div>
        </el-dialog>
        <!-- 销售历史 -->
        <el-dialog
            :title="SaleDialogTitle"
            :close-on-click-modal="false"
            :visible.sync="eyeHistoryVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
        >
            <div v-if="eyeHistoryVisible">
                <APHistory
                    ref="APHistory"
                    :showCusColumn="Source == 0"
                    :EntpCusId="EntpCusId"
                    :EntpCusName="EntpCusName"
                    :EntpTempGoodsId="hisGoodsId"
                    @closeDialog="eyeHistoryVisible = false"
                ></APHistory>
            </div>
        </el-dialog>
        <!-- 数据分析 -->
        <el-dialog
            :close-on-click-modal="false"
            title="商品销售采购数据图表"
            :visible.sync="goodsAnalysisVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
        >
            <div class="dialog-content" v-if="goodsAnalysisVisible">
                <goodsAnalysis ref="goodsAnalysis" :GoodsId="hisGoodsId" @closeDialog="goodsAnalysisVisible = false"></goodsAnalysis>
            </div>
        </el-dialog>
        <!-- 数量、单价预填写 -->
        <el-dialog
            :close-on-click-modal="false"
            title="加入清单"
            :visible.sync="rowVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            custom-class="add-row-dialog"
            style="margin-left: -170px"
        >
            <div class="form-div">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="汽配编码">
                        <el-input v-model="rowForm.APCode" disabled />
                    </el-form-item>
                    <el-form-item label="配件名称">
                        <el-input v-model="rowForm.GoodName" disabled />
                    </el-form-item>
                    <el-form-item label="车型">
                        <el-input v-model="rowForm.AutoSerise" disabled />
                    </el-form-item>
                    <el-form-item label="数量">
                        <el-input-number :min="1" :precision="0" controls-position="right" v-model="rowForm._count" />
                    </el-form-item>
                    <el-form-item label="价格">
                        <el-input-number :min="0" :precision="2" controls-position="right" v-model="rowForm._price" />
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialog-footer">
                <el-button class="btn-primary" size="small" @click="rowConfirm">提交</el-button>
                <el-button size="small" @click="rowClose">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import transInventory from '@/components/business/search/transInventory';
import elTableInfiniteScroll from '@/assets/js/directives/table-infinite-scroll';
import tableSets from '@/components/common/tableSets.vue';
import searchSets from '@/components/common/searchSets.vue';
import APPurchaseHistory from '@/components/common/APPurchaseHistory';
import APHistory from '@/components/common/APHistory';
import goodsAnalysis from '@/components/common/goodsAnalysis';
export default {
    name: '',
    props: [
        'EntpCusId',
        'EntpCusName',
        'canEdit',
        'OnlyOneOption',
        'StorageId',
        'IsGetNoSets',
        'IsOnlySets',
        'Source', //来源，0表示该组件用于销售单(1采购)编辑页面，来表示是否要判断仓位的类型；不需要的功能不必添加该属性
        'SelectedData', //已经选择了的数据，需要被过滤的数据
        'dragType', // 弹框类型：1 表示从开单页进入
        'dragSign' // 弹框标识
    ],
    components: {
        transInventory,
        tableSets,
        searchSets,
        APPurchaseHistory,
        APHistory,
        goodsAnalysis
    },
    data() {
        return {
            tableSetsVisible: false,
            searchSetVisible: false,
            addAPVisible: false,
            historyVisible: false,
            eyeHistoryVisible: false,
            goodsAnalysisVisible: false,
            SaleDialogTitle: '',
            hisGoodsId: '', //查看销售或采购历史的配件id
            loading: false,
            isIntentShow: false,
            typeList: [],
            brandList: [],
            dialogType: '-1',
            dialogVisible: false,
            isSearch: false,
            tableCode: 'DialogSearchAP',
            searchData: {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                APCode: '',
                GoodCode: '',
                GoodName: '',
                GoodDesc: '',
                AutoSerise: '',
                Brand: '',
                BrandName: [],
                Size: '',
                Cate: [],
                page: 1,
                limit: 20,
                CId: this.EntpCusId,
                SId: this.StorageId,
                SortProp: '',
                SortType: '',
                IsGetNoSets: false,
                IsOnlySets: false,
                Source: '',
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                SelectedData: [],
                ProjectId:''
            },
            tableData: [],
            tableDataLength: 0,
            selection: [],
            stopFresh: false,
            columnShowSets: {
                APCode: { ColumnName: '', IsShow: false, Width: 0 },
                GoodCode: { ColumnName: '', IsShow: false, Width: 0 },
                GoodName: { ColumnName: '', IsShow: false, Width: 0 },
                AutoSerise: { ColumnName: '', IsShow: false, Width: 0 },
                CostPrice: { ColumnName: '', IsShow: false, Width: 0 },
                Price: { ColumnName: '', IsShow: false, Width: 0 },
                MarketPrice: { ColumnName: '', IsShow: false, Width: 0 },
                Inventory: { ColumnName: '', IsShow: false, Width: 0 },
                Remaining: { Remaining: '', IsShow: false, Width: 0 },
                OrderWaitOutQuantity: { ColumnName: '', IsShow: false, Width: 0 },
                POrderWaitInQuantity: { ColumnName: '', IsShow: false, Width: 0 },
                Unit: { ColumnName: '', IsShow: false, Width: 0 },
                Cate: { ColumnName: '', IsShow: false, Width: 0 },
                Brand: { ColumnName: '', IsShow: false, Width: 0 },
                Origin: { ColumnName: '', IsShow: false, Width: 0 },
                Quality: { ColumnName: '', IsShow: false, Width: 0 },
                Size: { ColumnName: '', IsShow: false, Width: 0 },
                Size2: { ColumnName: '', IsShow: false, Width: 0 },
                Texture: { ColumnName: '', IsShow: false, Width: 0 },
                Color: { ColumnName: '', IsShow: false, Width: 0 },
                GoodDesc: { ColumnName: '', IsShow: false, Width: 0 },
                UpdateTime: { ColumnName: '', IsShow: false, Width: 0 },
                CreateTime: { ColumnName: '', IsShow: false, Width: 0 }
            },
            searchShowSets: {
                JointSearch: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                APCode: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                GoodName: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                GoodCode: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                AutoSerise: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                BrandId: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Cate: { Title: '', IsShow: false, SortNum: 0, Placeholder: '' },
                GoodDesc: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Invent: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Size: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                }
            },
            separator: '',
            isAddWaitIn: '',
            // 新增行内容
            rowVisible: false,
            rowForm: {},
            projectList:[],
            isShowProject:false
        };
    },
    watch: {
        tableData() {
            this.doLayout();
        }
    },
    created() {
        this.getStayCalValue();
        if (this.tableCode) {
            this.getSetsData();
            this.getSearchCrtSetsData();
            this.getJointSearchSets();
        }
        this.getConfigByCodes();
        this.getIntentDataValue();
    },
    mounted() {
        if (this.IsGetNoSets) this.searchData.IsGetNoSets = this.IsGetNoSets;
        if (this.IsOnlySets) this.searchData.IsOnlySets = this.IsOnlySets;
        this.searchData.Source = this.Source;
        // this.getTableData();
        // 打开时禁止页面滚动
        document.body.style = 'overflow:hidden';
    },
    destroyed() {
        document.body.style = 'overflow:auto';
    },
    directives: {
        'el-table-infinite-scroll': elTableInfiniteScroll
    },
    methods: {
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['hzxmxzset'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'hzxmxzset':
                                    this.isShowProject = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        // 单击一行，更新所有弹框内容
        rowClick(row) {
            if (this.historyVisible) {
                this.$refs.APPurchaseHistory.updateTableData(row.EntpTempGoodsId);
            }
            if (this.eyeHistoryVisible) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.$refs.APHistory.updateTableData(row.EntpTempGoodsId);
            }
            if (this.goodsAnalysisVisible) {
                this.$refs.goodsAnalysis.updateTableData(row.EntpTempGoodsId);
            }
            if (this.rowVisible) {
                this.dblChooseAps(row);
            }
        },
        /**
         * 表格滚动
         * 只有在滚动到底部，并且下方还有数据的情况下刷新
         */
        tableLoad() {
            if (!this.stopFresh) {
                if (this.tableData && this.tableData.length > 0) this.searchData.page += 1;
                else this.searchData.page = 1;
                this.getTableData();
            }
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.EntpTempGoodsId;
        },
        onColumnSelect(val) {
            this.selection = val;
        },
        // 选择配件
        chooseAP(item) {
            this.$emit('closeDialog', item);
        },
        //多选配件
        chooseAPs() {
            let items = this.selection;
            this.$emit('closeDialog', items);
        },
        chooseAllAPs() {
            this.searchData.limit = this.tableDataLength;
            this.searchData.page = 1;
            this.tableData = [];
            this.$emit('chooseAllAPsHandle', {
                searchData: this.searchData
            });
        },
        rowConfirm() {
            this.$emit('closeDialog', [this.rowForm], true);
            this.rowVisible = false;
        },
        rowClose() {
            this.rowVisible = false;
            this.rowForm = {};
        },
        // 列表双击打开弹框
        dblChooseAps(e) {
            if ([e][0] && this.dragType * 1 === 1) {
                let _price = 0;
                // 针对不同的开单页，赋予不同的价格
                if (this.dragSign === 'supplierRFQEdit') {
                    _price = e.Price;
                } else if (this.dragSign === 'transToSupplierOrder') {
                    _price = e.CostPrice;
                } else if (['bjEdit', 'salesOrderEdit'].includes(this.dragSign)) {
                    _price = e.LatestPrice;
                }
                this.rowVisible = true;
                this.rowForm = {
                    ...[e][0],
                    _count: 1,
                    _price
                };
            } else {
                this.$emit('closeDialog', [e]);
            }
        },
        showAddAPDialog() {
            this.addAPVisible = true;
        },
        showSearchSetDialog() {
            this.searchSetVisible = true;
        },
        showTableSetDialog() {
            this.tableSetsVisible = true;
        },
        closeAddAPDialog() {
            this.addAPVisible = false;
        },
        closeDialog(isEdit) {
            this.tableSetsVisible = false;
            this.searchSetVisible = false;
            if (isEdit) {
                this.$util.refresh();
            }
        },
        // 历史销售
        showHistories(id) {
            if (id) {
                this.hisGoodsId = id;
                this.historyVisible = true;
            }
        },
        //采购历史
        showSaleStat(row) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.hisGoodsId = row.EntpTempGoodsId;
                this.eyeHistoryVisible = true;
            }
        },
        analysis(row) {
            if (row) {
                this.hisGoodsId = row.EntpTempGoodsId;
                this.goodsAnalysisVisible = true;
            }
        },
        getGoodsBrand() {
            if (this.brandList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getGoodsType() {
            if (this.typeList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        resetSearch() {
            this.searchData = {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                APCode: '',
                GoodCode: '',
                GoodName: '',
                GoodDesc: '',
                AutoSerise: '',
                Size: '',
                CId: this.EntpCusId,
                Brand: '',
                BrandName: [],
                Cate: [],
                page: 1,
                limit: 20,
                SId: this.StorageId,
                SortProp: '',
                SortType: '',
                IsGetNoSets: this.IsGetNoSets,
                IsOnlySets: this.IsOnlySets,
                Source: this.Source,
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                ProjectId:''
            };
            this.isSearch = false;
        },
        getTableData() {
            return new Promise(resolve => {
                if (this.searchData.Symbol) {
                    if (this.searchData.Symbol == 'between') {
                        if (isNaN(this.searchData.Invent1)) {
                            this.$util.warningMsg('请输入正确的库存数');
                            return;
                        }
                        if (isNaN(this.searchData.Invent2)) {
                            this.$util.warningMsg('请输入正确的库存数');
                            return;
                        }
                    } else {
                        if (isNaN(this.searchData.Invent1)) {
                            this.$util.warningMsg('请输入正确的库存数');
                            return;
                        }
                    }
                }
                if (this.SelectedData && this.SelectedData.length > 0) {
                    this.searchData.SelectedData = this.SelectedData;
                }

                this.loading = true;
                this.stopFresh = true;
                this.$util
                    .axiosPost({
                        url: '/api/EntpUnionGoods/GetGoodsListForUnion',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        this.loading = false;
                        let data = res.data;
                        this.tableDataLength = res.count;
                        if (!data) {
                            if (this.searchData.page == 1) this.tableData = [];
                            return;
                        }
                        let list = [...this.tableData, ...data];
                        const maps = new Map();
                        list = list.filter(m => !maps.has(m.EntpTempGoodsId) && maps.set(m.EntpTempGoodsId, 1));
                        this.tableData = list;
                        this.stopFresh = data.length < this.searchData.limit;
                        resolve(this.tableData);
                    })
                    .catch(e => {
                        this.loading = false;
                    });
            });
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.tableData = [];
            this.getTableData();
        },
        handleSearch() {
            this.searchData.page = 1;
            this.tableData = [];
            this.$refs.dialogTable.clearSelection();
            this.isSearch = true;
            // 防止多次点击
            if (!this.loading) {
                this.getTableData();
            }
        },
        projectVisibleChange() {
            let that = this;
            if (that.projectList.length == 0) {
                that.$util.getAuthCoProjects().then(data => {
                    if (data) that.projectList = data;
                });
            }
        },
        getSetsData() {
            this.$util.getTableSetsData(this.tableCode, true).then(data => {
                data.forEach(item => {
                    switch (item.ColumnCode) {
                        case 'APCode':
                            this.columnShowSets.APCode.IsShow = item.IsShow;
                            this.columnShowSets.APCode.Width = item.Width;
                            this.columnShowSets.APCode.ColumnName = item.ColumnName;
                            break;
                        case 'GoodCode':
                            this.columnShowSets.GoodCode.IsShow = item.IsShow;
                            this.columnShowSets.GoodCode.Width = item.Width;
                            this.columnShowSets.GoodCode.ColumnName = item.ColumnName;
                            break;
                        case 'GoodName':
                            this.columnShowSets.GoodName.IsShow = item.IsShow;
                            this.columnShowSets.GoodName.Width = item.Width;
                            this.columnShowSets.GoodName.ColumnName = item.ColumnName;
                            break;
                        case 'AutoSerise':
                            this.columnShowSets.AutoSerise.IsShow = item.IsShow;
                            this.columnShowSets.AutoSerise.Width = item.Width;
                            this.columnShowSets.AutoSerise.ColumnName = item.ColumnName;
                            break;
                        case 'CostPrice':
                            this.columnShowSets.CostPrice.IsShow = item.IsShow;
                            this.columnShowSets.CostPrice.Width = item.Width;
                            this.columnShowSets.CostPrice.ColumnName = item.ColumnName;
                            break;
                        case 'Price':
                            this.columnShowSets.Price.IsShow = item.IsShow;
                            this.columnShowSets.Price.Width = item.Width;
                            this.columnShowSets.Price.ColumnName = item.ColumnName;
                            break;
                        case 'MarketPrice':
                            this.columnShowSets.MarketPrice.IsShow = item.IsShow;
                            this.columnShowSets.MarketPrice.Width = item.Width;
                            this.columnShowSets.MarketPrice.ColumnName = item.ColumnName;
                            break;
                        case 'Inventory':
                            this.columnShowSets.Inventory.IsShow = item.IsShow;
                            this.columnShowSets.Inventory.Width = item.Width;
                            this.columnShowSets.Inventory.ColumnName = item.ColumnName;
                            break;
                        case 'Remaining':
                            this.columnShowSets.Remaining.IsShow = item.IsShow;
                            this.columnShowSets.Remaining.Width = item.Width;
                            this.columnShowSets.Remaining.ColumnName = item.ColumnName;
                            break;
                        case 'OrderWaitOutQuantity':
                            this.columnShowSets.OrderWaitOutQuantity.IsShow = item.IsShow;
                            this.columnShowSets.OrderWaitOutQuantity.Width = item.Width;
                            this.columnShowSets.OrderWaitOutQuantity.ColumnName = item.ColumnName;
                            break;
                        case 'POrderWaitInQuantity':
                            this.columnShowSets.POrderWaitInQuantity.IsShow = item.IsShow;
                            this.columnShowSets.POrderWaitInQuantity.Width = item.Width;
                            this.columnShowSets.POrderWaitInQuantity.ColumnName = item.ColumnName;
                            break;
                        case 'Unit':
                            this.columnShowSets.Unit.IsShow = item.IsShow;
                            this.columnShowSets.Unit.Width = item.Width;
                            this.columnShowSets.Unit.ColumnName = item.ColumnName;
                            break;
                        case 'Cate':
                            this.columnShowSets.Cate.IsShow = item.IsShow;
                            this.columnShowSets.Cate.Width = item.Width;
                            this.columnShowSets.Cate.ColumnName = item.ColumnName;
                            break;
                        case 'Brand':
                            this.columnShowSets.Brand.IsShow = item.IsShow;
                            this.columnShowSets.Brand.Width = item.Width;
                            this.columnShowSets.Brand.ColumnName = item.ColumnName;
                            break;
                        case 'Origin':
                            this.columnShowSets.Origin.IsShow = item.IsShow;
                            this.columnShowSets.Origin.Width = item.Width;
                            this.columnShowSets.Origin.ColumnName = item.ColumnName;
                            break;
                        case 'Quality':
                            this.columnShowSets.Quality.IsShow = item.IsShow;
                            this.columnShowSets.Quality.Width = item.Width;
                            this.columnShowSets.Quality.ColumnName = item.ColumnName;
                            break;
                        case 'Size':
                            this.columnShowSets.Size.IsShow = item.IsShow;
                            this.columnShowSets.Size.Width = item.Width;
                            this.columnShowSets.Size.ColumnName = item.ColumnName;
                            break;
                        case 'Size2':
                            this.columnShowSets.Size2.IsShow = item.IsShow;
                            this.columnShowSets.Size2.Width = item.Width;
                            this.columnShowSets.Size2.ColumnName = item.ColumnName;
                            break;
                        case 'Texture':
                            this.columnShowSets.Texture.IsShow = item.IsShow;
                            this.columnShowSets.Texture.Width = item.Width;
                            this.columnShowSets.Texture.ColumnName = item.ColumnName;
                            break;
                        case 'Color':
                            this.columnShowSets.Color.IsShow = item.IsShow;
                            this.columnShowSets.Color.Width = item.Width;
                            this.columnShowSets.Color.ColumnName = item.ColumnName;
                            break;
                        case 'GoodDesc':
                            this.columnShowSets.GoodDesc.IsShow = item.IsShow;
                            this.columnShowSets.GoodDesc.Width = item.Width;
                            this.columnShowSets.GoodDesc.ColumnName = item.ColumnName;
                            break;
                        case 'UpdateTime':
                            this.columnShowSets.UpdateTime.IsShow = item.IsShow;
                            this.columnShowSets.UpdateTime.Width = item.Width;
                            this.columnShowSets.UpdateTime.ColumnName = item.ColumnName;
                            break;
                        case 'CreateTime':
                            this.columnShowSets.CreateTime.IsShow = item.IsShow;
                            this.columnShowSets.CreateTime.Width = item.Width;
                            this.columnShowSets.CreateTime.ColumnName = item.ColumnName;
                            break;
                    }
                });
            });
        },
        getJointSearchSets() {
            this.$util.getJointSearchSetsData(true).then(data => {
                data.forEach(item => {
                    if (item.IsSeparator) {
                        this.separator = item.Separator;
                        return;
                    }
                });
            });
        },
        getSearchCrtSetsData() {
            this.$util.getSearchCrtSetsData('SearchUnionAP', true).then(data => {
                data.forEach(item => {
                    switch (item.SearchCode) {
                        case 'JointSearch':
                            this.searchShowSets.JointSearch.IsShow = item.IsShow;
                            this.searchShowSets.JointSearch.Width = item.Width;
                            this.searchShowSets.JointSearch.Placeholder = item.Placeholder;
                            this.searchShowSets.JointSearch.Title = item.Title;
                            this.searchShowSets.JointSearch.SortNum = item.SortNum;
                            break;
                        case 'APCode':
                            this.searchShowSets.APCode.IsShow = item.IsShow;
                            this.searchShowSets.APCode.Width = item.Width;
                            this.searchShowSets.APCode.Placeholder = item.Placeholder;
                            this.searchShowSets.APCode.Title = item.Title;
                            this.searchShowSets.APCode.SortNum = item.SortNum;
                            break;
                        case 'GoodName':
                            this.searchShowSets.GoodName.IsShow = item.IsShow;
                            this.searchShowSets.GoodName.Width = item.Width;
                            this.searchShowSets.GoodName.Placeholder = item.Placeholder;
                            this.searchShowSets.GoodName.Title = item.Title;
                            this.searchShowSets.GoodName.SortNum = item.SortNum;
                            break;
                        case 'GoodCode':
                            this.searchShowSets.GoodCode.IsShow = item.IsShow;
                            this.searchShowSets.GoodCode.Width = item.Width;
                            this.searchShowSets.GoodCode.Placeholder = item.Placeholder;
                            this.searchShowSets.GoodCode.Title = item.Title;
                            this.searchShowSets.GoodCode.SortNum = item.SortNum;
                            break;
                        case 'AutoSerise':
                            this.searchShowSets.AutoSerise.IsShow = item.IsShow;
                            this.searchShowSets.AutoSerise.Width = item.Width;
                            this.searchShowSets.AutoSerise.Placeholder = item.Placeholder;
                            this.searchShowSets.AutoSerise.Title = item.Title;
                            this.searchShowSets.AutoSerise.SortNum = item.SortNum;
                            break;
                        case 'BrandId':
                            this.searchShowSets.BrandId.IsShow = item.IsShow;
                            this.searchShowSets.BrandId.Width = item.Width;
                            this.searchShowSets.BrandId.Placeholder = item.Placeholder;
                            this.searchShowSets.BrandId.Title = item.Title;
                            this.searchShowSets.BrandId.SortNum = item.SortNum;
                            break;
                        case 'Cate':
                            this.searchShowSets.Cate.IsShow = item.IsShow;
                            this.searchShowSets.Cate.Width = item.Width;
                            this.searchShowSets.Cate.Placeholder = item.Placeholder;
                            this.searchShowSets.Cate.Title = item.Title;
                            this.searchShowSets.Cate.SortNum = item.SortNum;
                            break;
                        case 'GoodDesc':
                            this.searchShowSets.GoodDesc.IsShow = item.IsShow;
                            this.searchShowSets.GoodDesc.Width = item.Width;
                            this.searchShowSets.GoodDesc.Placeholder = item.Placeholder;
                            this.searchShowSets.GoodDesc.Title = item.Title;
                            this.searchShowSets.GoodDesc.SortNum = item.SortNum;
                            break;
                        case 'Invent':
                            this.searchShowSets.Invent.IsShow = item.IsShow;
                            this.searchShowSets.Invent.Width = item.Width;
                            this.searchShowSets.Invent.Placeholder = item.Placeholder;
                            this.searchShowSets.Invent.Title = item.Title;
                            this.searchShowSets.Invent.SortNum = item.SortNum;
                            break;
                        case 'Size':
                            this.searchShowSets.Size.IsShow = item.IsShow;
                            this.searchShowSets.Size.Width = item.Width;
                            this.searchShowSets.Size.Placeholder = item.Placeholder;
                            this.searchShowSets.Size.Title = item.Title;
                            this.searchShowSets.Size.SortNum = item.SortNum;
                            break;
                    }
                });
            });
        },
        // 重新渲染table组件，用于处理刷新页面后配置 fixed="right" 的列出现样式错误的问题
        doLayout() {
            this.$nextTick(() => {
                this.$refs.dialogTable.doLayout();
            });
        },
        //获取留余的计算方式
        getStayCalValue() {
            this.$util.getSysConfig('lybsdr').then(res => {
                this.isAddWaitIn = !res.Result;
            });
        },
        //获取在订展示配置
        getIntentDataValue() {
            this.$util.getSysConfig('syztsj').then(res => {
                this.isIntentShow = res.Result;
            });
        }
    }
};
</script>
<style lang="less" scoped>
.search-ctn {
    margin-top: 5px;
}
.option-content {
    display: flex;
    line-height: 30px;
}
.searchAp-ctn {
    // height: 615px;
    overflow-y: auto;
}
.search-ctn-left {
    .search-row {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        margin-top: 5px;
    }
}
.ops-ctn {
    display: flex;
    flex-direction: row;
    align-items: center;

    > i {
        margin-left: 10px;
        cursor: pointer;
    }
    .scolor {
        color: #db3737;
    }
    .pcolor {
        color: #0f9960;
    }
}
</style>
<style lang="less">
.search-table-i {
    .el-table {
        .el-table__body {
            .current-row {
                > td {
                    background-color: #bbddff;
                }
            }
            .el-table__row {
                .cell {
                    button {
                        padding: 0;
                    }
                }
                td {
                    padding: 2px 0;
                }
            }
        }
        th {
            padding: 4px 0;
        }
    }
}
.searchAp-ctn {
    .el-select {
        .el-select__tags {
            flex-wrap: nowrap;
            overflow: hidden;
        }
    }
    .el-table {
        .el-table__row:hover > td {
            background-color: #dcdee1;
        }
    }
}
#change-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        width: 1000px;
        height: 500px;
        box-shadow: 0 0 9px 3px #999;
    }
    .add-row-dialog {
        width: 340px;
        height: auto;
        .form-div {
            margin-top: 20px;
        }
        .dialog-footer {
            text-align: right;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
